<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <!--Boxicons v3.0.8 https://boxicons.com | License  https://docs.boxicons.com/free-->
    <path
      d="M14.82 4c-.41-1.16-1.51-2-2.82-2s-2.4.84-2.82 2H2v2h2.56l-2.49 6.65c-.04.11-.06.23-.06.35 0 2.21 1.79 4 4 4s4-1.79 4-4c0-.12-.02-.24-.06-.35L7.46 6H9.2c.3.85.97 1.51 1.82 1.82V20H2v2h20v-2h-9V7.82c.85-.3 1.51-.97 1.82-1.82h1.74l-2.49 6.65c-.04.11-.06.23-.06.35 0 2.21 1.79 4 4 4s4-1.79 4-4c0-.12-.02-.24-.06-.35L19.46 6h2.56V4h-7.18ZM4.07 13 6 7.85 7.93 13zm12 0L18 7.85 19.93 13zM12 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
    ></path>
  </svg>
</template>
